let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eU8ol")).then(() => parcelRequire('dM6s0'));